<script setup lang="ts">
const props = defineProps<{
  id: string;
  label?: string;
}>();

const defaultLabel = 'Is this property expected to generate rental income?';
</script>
<template>
  <BxField v-slot="{ field }" name="receiveRentalIncome">
    <BxRadio
      v-bind="field"
      :id="id + '-rental-income'"
      :label="props.label ?? defaultLabel"
      label-type="default"
      class="form-control incoming-margin-top"
      boolean
    />
  </BxField>
</template>
